import { createAsyncThunk } from "@reduxjs/toolkit";
import { Axios } from "api/axios";
import { API_ENDPOINT } from "helpers/Endpoints/endpoints";

export const fetchPermissions = createAsyncThunk(
  "permissions/fetchPermissions",
  async (_, { rejectWithValue }) => {
    try {
      const response = await Axios.get(API_ENDPOINT.USER_MANAGEMENT.MODULE.LIST);
      return response.data.data;
    } catch (error: any) {
      return rejectWithValue(
        error?.response?.data?.message || "Failed to fetch modules"
      );
    }
  }
);

export const fetchPermissionsById = createAsyncThunk(
  "permissions/fetchPermissionsById",
  async (userId: string, { rejectWithValue }) => {
    try {
      const response = await Axios.get(
        API_ENDPOINT.USER_MANAGEMENT.PERMISSION.GET_USER_PERMISSIONS(userId)
      );
      console.log("response, line 26", response.data)
      // Response structure: { status, success, message, data: { user_id, apps_permissions: [...] } }
      return response.data?.data?.apps_permissions || [];
    } catch (error: any) {
      return rejectWithValue(
        error?.response?.data?.message || "Failed to fetch permissions"
      );
    }
  }
);

export const submitPermissions = createAsyncThunk(
  "permissions/submitPermissions",
  async (payload: any, { rejectWithValue }) => {
    try {
      const response = await Axios.post(
        API_ENDPOINT.USER_MANAGEMENT.PERMISSION.CREATE_PERMISSIONS_LIST,
        payload
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error);
    }
  }
);

export const updateUserPermissions = createAsyncThunk(
  "permissions/updateUserPermissions",
  async ({ userId, payload }: { userId: string; payload: any }, { rejectWithValue }) => {
    try {
      const response = await Axios.put(
        API_ENDPOINT.USER_MANAGEMENT.PERMISSION.UPDATE_PERMISSIONS_LIST(userId),
        payload
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error?.response?.data?.message || "Failed to update permissions"
      );
    }
  }
);

export const deleteAllUserPermissions = createAsyncThunk(
  "permissions/deleteAllUserPermissions",
  async (userId: string, { rejectWithValue }) => {
    try {
      const response = await Axios.delete(
        API_ENDPOINT.USER_MANAGEMENT.PERMISSION.DELETE_ALL_PERMISSIONS(userId)
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error?.response?.data?.message || "Failed to delete permissions"
      );
    }
  }
);

export const checkPermission = createAsyncThunk(
  "permissions/checkPermission",
  async (queryParams: { app_name?: string; module_name?: string; action?: string }, { rejectWithValue }) => {
    try {
      const params = new URLSearchParams();
      if (queryParams.app_name) params.append("app_name", queryParams.app_name);
      if (queryParams.module_name) params.append("module_name", queryParams.module_name);
      if (queryParams.action) params.append("action", queryParams.action);
      
      const response = await Axios.get(
        `${API_ENDPOINT.USER_MANAGEMENT.PERMISSION.CHECK_PERMISSION}?${params.toString()}`
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error?.response?.data?.message || "Failed to check permission"
      );
    }
  }
);

export const getAllPermissions = createAsyncThunk(
  "permissions/getAllPermissions",
  async (_, { rejectWithValue }) => {
    try {
      const response = await Axios.get(API_ENDPOINT.USER_MANAGEMENT.PERMISSION.LIST);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error?.response?.data?.message || "Failed to fetch all permissions"
      );
    }
  }
);

export const getPermissionById = createAsyncThunk(
  "permissions/getPermissionById",
  async (permissionId: string, { rejectWithValue }) => {
    try {
      const response = await Axios.get(
        API_ENDPOINT.USER_MANAGEMENT.PERMISSION.DETAIL(permissionId)
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error?.response?.data?.message || "Failed to fetch permission"
      );
    }
  }
);

export const getUserPermissionResponse = createAsyncThunk(
  "permissions/getUserPermissionResponse",
  async (userId: string, { rejectWithValue }) => {
    try {
      const response = await Axios.get(
        API_ENDPOINT.USER_MANAGEMENT.PERMISSION.GET_USER_PERMISSION_RESPONSE(userId)
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error?.response?.data?.message || "Failed to fetch user permission response"
      );
    }
  }
);

export const deletePermission = createAsyncThunk(
  "permissions/deletePermission",
  async (permissionId: string, { rejectWithValue }) => {
    try {
      const response = await Axios.delete(
        API_ENDPOINT.USER_MANAGEMENT.PERMISSION.DELETE(permissionId)
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error?.response?.data?.message || "Failed to delete permission"
      );
    }
  }
);
